<template>
<div class="stepDetails">
  <el-row>
    <el-steps :active="active">
      <el-step title="步骤 一" icon="el-icon-download" description="请下载批量上传模板"></el-step>
      <el-step title="步骤 二" icon="el-icon-edit" description="按照模板内容，填入相关会员资料"></el-step>
      <el-step title="步骤 三" icon="el-icon-upload" description="上传已填写的会员资料模板"></el-step>
      <el-step title="步骤 四" description="完成" finish-status="success"></el-step>
    </el-steps>
  </el-row>
  <div class="stepDet">
    <el-row v-if="active == 3" style="margin-bottom:30px;">
      <el-upload class="uploadLists" drag multiple ref='upload' :action="importMems" :file-list="fileListData" accept='.xlsx,.xls,.pdf' :before-Upload="beforeAUpload" :before-remove="beforeRemove" :on-remove="handleRemove" :on-change='addFile' :on-error="uploadError" :auto-upload="false">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">点击或将文件拖拽到这里上传</div>
        <div class="el-upload__text" style="color: #9e9e9e;font-size:12px;">支持扩展名：.xlsx .xls .pdf...</div>
      </el-upload>
    </el-row>
    <el-row v-if="active == 4" style="margin-bottom:30px;">
      <span class="sucesOp el-icon-check"></span>
      <b class="sucesOp2">提交成功</b>
    </el-row>
    <el-row v-if="active == 1">
      <p>下载文件：<span style="color: #ababab;">批量上传会员模板.xlsx</span></p>
      <el-button type="success" plain @click="outportExcel">下载文件</el-button>
      <el-button @click="next(2)">我已下载，下一步</el-button>
    </el-row>
    <el-row v-if="active == 2">
      <el-button  @click="next(1)">表格还未下载，上一步</el-button>
      <el-button type="success" @click="next(2)" plain>我已填写完毕，下一步</el-button>
    </el-row>
    <el-row v-if="active == 3">
      <el-button  @click="next(1)">表格还未填写，上一步</el-button>
      <el-button type="success" @click="submitUpload" plain>我已上传完毕，下一步</el-button>
    </el-row>
    <el-row v-if="active == 4">
      <!-- <el-button  @click="next(1)">表格还未上传，上一步</el-button> -->
      <el-button type="success" @click="stepDetOp" plain>完成</el-button>
    </el-row>
  </div>

</div>
</template>
<script>
import {templateDownLoad, importMembers, templateDownLoadOther, importMembersOther} from "@/api";
export default {
  data() {
    return {
      active: 1,
      fileList:[],
      fileListData:[],
      importMems:this.$store.state.userInfo.brandId == 1 ? importMembers:importMembersOther,
    };
  },
  created() {
    this.active =  this.$store.state.alivePage;
    // this.$store.state.userInfo.brandId
  },
  methods: {
    submitUpload() {
      if (this.fileList.length === 0){
        this.$message.warning('请上传文件');
      }else{
        this.$confirm('确定要提交文件吗？', '提示', {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type:"warning"
        }).then(() => {
            let form = new FormData();
            for(let i of this.fileList){
              form.append('files', i);
            }
            this.$http.post(this.importMems, form, {
              headers:{
                userId:this.$store.state.userInfo.redisKey
              }
            }).then(res => {
              if(res.data.code == 1){
                this.$message({
                  type:"success",
                  message: res.data.msg
                });
                setTimeout(() => {
                  if (this.active++ > 3) this.active = 4;
                  this.$store.commit('setAlivePage',this.active)
                }, 500);
              }else{
                this.$message({
                  type:"error",
                  message: res.data.msg
                });
              }
            });
        }).catch(action => {
            this.$message({
                type: "warning",
                message: "error"
            });
        });
      }
    },
    stepDetOp(){
      this.$router.push('/basicDataCenter/baseInfo')
    },
    next(type) {
      if(type == 1){
        this.active--;
      }else if (this.active++ > 3){
        this.active = 4
      };
      this.$store.commit('setAlivePage',this.active)
    },
    outportExcel(){// 导出
      let templats = this.$store.state.userInfo.brandId == 1 ? templateDownLoad:templateDownLoadOther;
      this.$http.post(templats, {}, {
        headers:{
          userId:this.$store.state.userInfo.redisKey
        },
        responseType: "blob"
      })
      .then(res => {
        const blob = new Blob([res.data], {type: 'application/vnd.ms-excel'});
        const fileName = '会员模板.xls';
        if ('download' in document.createElement('a')) {
          const elink = document.createElement('a');
          elink.download = fileName;
          elink.style.display = 'none';
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href);
          document.body.removeChild(elink);
        }else{
          navigator.msSaveBlob(blob, fileName);
        }
        this.$nextTick(()=>{
          this.openFlag = false;
        })
      })
    },
    UploadUrl(){
      return "";
    },
    beforeAUpload(file) {
    const extension = file.name.split(".")[1] === "xlsx";
    const extension1 = file.name.split(".")[1] === "xls";
    if (!extension && !extension1) {
      this.$message({
        message: "上传模板只能是 .xlsx,.xls 格式!",
        type: "error"
      });
      }
      return extension || extension1;
    },
    beforeRemove(file, fileList) {
      const extension = file.name.split(".")[1] === "xlsx";
      const extension1 = file.name.split(".")[1] === "xls";
      if ((!extension && !extension1) || this.uploadShow == true) {
        return;
      } else {
        if (file) {
         return this.$confirm(`确定移除 ${file.name}？`);
        }
      }
    },
    uploadError(response, file, fileList) {// 上传错误
      this.$message({
        message: "上传失败，请重试！",
        type: "error"
      });
    },
    addFile(file, fileList) {
      const extension = file.name.split(".")[1] === "xlsx";
      const extension1 = file.name.split(".")[1] === "xls";
      if (!extension && !extension1) {
        return;
      }else{
        this.fileList.push(file.raw);
        this.fileListData.push({name:file.raw.name,uid:file.raw.uid});
      }
    },
    handleRemove(file, fileList) {
      this.fileListData = [];
      this.fileListData = fileList;
      for(let i in this.fileList){
        if(this.fileList[i].name == file.name){
          this.fileList.splice(i,1);
        }
      };
    },

  }
};
</script>
<style lang="less" scoped>
.stepDetails {
  width: 100%;
  overflow: hidden;
  padding: 80px 50px 70px;
  position: relative;
  .stepDet{margin:80px auto; text-align: center;
    p{text-indent: -6em;margin:0 0 20px;}
  }
  .el-button--primary, .el-button, .el-button--danger{border-radius:0px !important;margin-right:10px;}
  .uploadLists {
    display: inline-block;
  }
  .sucesOp{background: #67C23A;display: block;color: #fff;width:80px;height: 80px;line-height: 80px;text-align: center;border-radius: 8em;font-size:50px;font-weight: bolder;margin:0 auto;}
  .sucesOp2{display: block;text-align: center;font-size:30px;margin:20px auto 80px;}

}
</style>
<style lang="less">
.stepDetails {
  .el-upload-dragger{background-color:#f9f9f9;}
}
</style>



// WEBPACK FOOTER //
// src/components/basicDataCenter/baseAdd.vue